
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parascolastico",
      function () {
        return require("private-next-pages/parascolastico/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parascolastico"])
      });
    }
  